(function () {
  var SECTION_SELECTOR = '[data-product-section]';

  function init(root) {
    if (!root || root.dataset.productInit === 'true') return;
    root.dataset.productInit = 'true';

    var controller = new AbortController();
    root.productController = controller;
    var signal = { signal: controller.signal };

    /* ---------- Image slider ---------- */
    var slider = root.querySelector('[data-slider]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var currentIndex = 0;

    // Declared even when the slider is absent so the variant-pill handler
    // below can call it unconditionally without re-checking slider presence.
    /* Below lg the track is a native scroll-snap strip so swiping gets real
       momentum and rubber-banding; at lg and above it keeps the JS transform
       it has always used. A transform on a scroll container fights the
       scrolling, so only one of the two may be active at a time. */
    var desktopQuery = window.matchMedia('(min-width: 1024px)');

    var updateSliderPosition = function () {
      if (!slider) return;

      if (desktopQuery.matches) {
        slider.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
      } else {
        /* Clear any transform left over from a resize, or the track would sit
           offset from wherever it is scrolled to. */
        slider.style.transform = '';
        var target = slider.children[currentIndex];
        if (target) {
          slider.scrollTo({
            left: target.offsetLeft - slider.offsetLeft,
            behavior: 'smooth'
          });
        }
      }

      // Additive hook only — motion.js listens for this to layer a crossfade
      // on top of the slide. No existing behaviour above is changed.
      slider.dispatchEvent(new CustomEvent('mo:slide-change', { detail: { index: currentIndex }, bubbles: true }));
    };

    // Jumps to the slide matching a variant's featured image, if it's one
    // of the product's images (falls back to leaving the slide as-is).
    var goToImageId = function (imageId) {
      if (!slider || !imageId) return;
      var slides = slider.children;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-image-id') === imageId) {
          currentIndex = i;
          updateSliderPosition();
          return;
        }
      }
    };

    /* A swipe moves the track without going through updateSliderPosition,
       so currentIndex would go stale and the next arrow press would jump back
       to wherever the code last thought it was. Read the scroll position back
       after it settles.

       requestAnimationFrame-throttled: scroll fires at frame rate on touch and
       recomputing per event is wasted work. */
    if (slider) {
      var syncQueued = false;
      slider.addEventListener(
        'scroll',
        function () {
          if (desktopQuery.matches || syncQueued) return;
          syncQueued = true;
          window.requestAnimationFrame(function () {
            syncQueued = false;
            var width = slider.clientWidth;
            if (!width) return;
            var i = Math.round(slider.scrollLeft / width);
            i = Math.max(0, Math.min(slider.children.length - 1, i));
            if (i !== currentIndex) {
              currentIndex = i;
              slider.dispatchEvent(
                new CustomEvent('mo:slide-change', {
                  detail: { index: currentIndex },
                  bubbles: true
                })
              );
            }
          });
        },
        { passive: true }
      );

      /* Crossing the breakpoint leaves the track in the other mode's state —
         a stale transform on mobile, or a scroll offset on desktop. Re-apply
         for whichever mode is now active. */
      desktopQuery.addEventListener('change', function () {
        if (desktopQuery.matches) slider.scrollLeft = 0;
        updateSliderPosition();
      });
    }

    if (slider && prev && next) {
      prev.addEventListener(
        'click',
        function () {
          var count = slider.children.length;
          currentIndex = currentIndex > 0 ? currentIndex - 1 : count - 1;
          updateSliderPosition();
        },
        signal
      );

      next.addEventListener(
        'click',
        function () {
          var count = slider.children.length;
          currentIndex = currentIndex < slider.children.length - 1 ? currentIndex + 1 : 0;
          updateSliderPosition();
        },
        signal
      );
    }

    /* ---------- Variant pills ----------
       Selecting a pill updates: the hidden form input (so the right variant
       adds to cart), price, size/material text, the Add to Cart button's
       enabled state and label, and jumps the image slider to the variant's
       featured image. Pill colours themselves are pre-rendered by Liquid
       (see product-page-content.liquid) since they embed settings-driven
       hex values that JS can't resolve — this only toggles which set of
       classes is applied. */
    var variantInput = root.querySelector('[data-variant-input]');
    var pillGroup = root.querySelector('[data-selected-class]');
    var pills = root.querySelectorAll('[data-variant-pill]');
    var priceEl = root.querySelector('[data-variant-price]');
    var comparePriceEl = root.querySelector('[data-variant-compare-price]');
    var sizeEl = root.querySelector('[data-variant-size]');
    var addToCartBtn = root.querySelector('[data-addtocart-button]');
    var addToCartLabel = root.querySelector('[data-addtocart-label]');

    if (pills.length && pillGroup) {
      var selectedClasses = (pillGroup.getAttribute('data-selected-class') || '').split(' ').filter(Boolean);
      var unselectedClasses = (pillGroup.getAttribute('data-unselected-class') || '').split(' ').filter(Boolean);

      pills.forEach(function (pill) {
        pill.addEventListener(
          'click',
          function () {
            if (pill.disabled) return;

            pills.forEach(function (other) {
              var isThisOne = other === pill;
              other.classList.remove.apply(other.classList, isThisOne ? unselectedClasses : selectedClasses);
              other.classList.add.apply(other.classList, isThisOne ? selectedClasses : unselectedClasses);
              other.setAttribute('aria-pressed', isThisOne ? 'true' : 'false');
            });

            if (variantInput) variantInput.value = pill.getAttribute('data-variant-id');

            if (priceEl) priceEl.textContent = pill.getAttribute('data-price');
            if (comparePriceEl) {
              var onSale = pill.getAttribute('data-on-sale') === 'true';
              comparePriceEl.textContent = pill.getAttribute('data-compare-price');
              comparePriceEl.classList.toggle('hidden', !onSale);
            }

            if (sizeEl) sizeEl.textContent = pill.getAttribute('data-option1') || '';

            var available = pill.getAttribute('data-available') === 'true';
            if (addToCartBtn) {
              addToCartBtn.disabled = !available;
              addToCartBtn.classList.toggle('opacity-50', !available);
              addToCartBtn.classList.toggle('cursor-not-allowed', !available);
              if (addToCartLabel) {
                addToCartLabel.textContent = available
                  ? addToCartBtn.getAttribute('data-add-to-cart-label')
                  : addToCartBtn.getAttribute('data-sold-out-label');
              }
            }

            goToImageId(pill.getAttribute('data-image-id'));
          },
          signal
        );
      });
    }

    /* ---------- Accordion ---------- */
    var toggles = root.querySelectorAll('[data-accordion-toggle]');

    toggles.forEach(function (toggle) {
      toggle.addEventListener(
        'click',
        function () {
          var panelId = toggle.getAttribute('aria-controls');
          var panel = panelId ? root.querySelector('#' + panelId) : null;
          if (!panel) return;

          var isOpen = toggle.getAttribute('aria-expanded') === 'true';

          // Close every panel first (single-open accordion).
          toggles.forEach(function (other) {
            var otherPanel = root.querySelector('#' + other.getAttribute('aria-controls'));
            other.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.classList.add('hidden');
          });

          if (!isOpen) {
            toggle.setAttribute('aria-expanded', 'true');
            panel.classList.remove('hidden');
          }
        },
        signal
      );
    });
  }

  function teardown(root) {
    if (!root) return;
    if (root.productController) {
      root.productController.abort();
      delete root.productController;
    }
    root.removeAttribute('data-product-init');
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(init);

  if (!window.__productSectionWired) {
    window.__productSectionWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector(SECTION_SELECTOR);
      if (root) init(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector(SECTION_SELECTOR);
      if (root) teardown(root);
    });
  }
})();
